import React from "react";
import { Box, Backdrop, Fade, Zoom } from "@mui/material";
import ChristmasPromoCard from "./ChristmasPromoCard";

type ChristmasPromoModalProps = {
  open: boolean;
  onClose: () => void;
};

const ChristmasPromoModal: React.FC<ChristmasPromoModalProps> = ({
  open,
  onClose,
}) => {
  if (!open) return null;

  return (
    <>
      <Backdrop
        open={open}
        onClick={onClose}
        sx={{
          zIndex: 1200,
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(4px)",
          transition: "all 0.3s ease-in-out",
        }}
      />
      <Fade in={open} timeout={400}>
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1300,
            maxHeight: "90vh",
            overflowY: "auto",
            overflowX: "hidden",
            // Custom scrollbar
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.3)",
              },
            },
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Zoom in={open} timeout={500} style={{ transitionDelay: open ? "100ms" : "0ms" }}>
            <Box>
              <ChristmasPromoCard onClose={onClose} />
            </Box>
          </Zoom>
        </Box>
      </Fade>
    </>
  );
};

export default ChristmasPromoModal;
